// copy from sass variables and made globally available
window.xxsWidth = 320;
window.maxXxs = 413;
window.xsWidth = 414;
window.maxXs = 599;
window.smWidth = 600;
window.maxSm = 767;
window.mdWidth = 768;
window.maxMd = 1023;
window.lgWidth = 1024;
window.maxLg = 1439;
window.xlWidth = 1440;

// set global media breakpoints - these vars (sizes) exist already here above - we can use these breakpoints for usage to check mediaBreakpoint
// if you need one! Please add yours here - but use above VAR naming
window.mediaBreakPointMaxXxs = window.matchMedia('(max-width:' + maxXxs + 'px)');
window.mediaBreakPointMaxXs = window.matchMedia('(max-width:' + maxXs + 'px)');
window.mediaBreakPointMinXsMaxSm = window.matchMedia('(min-width:' + xsWidth + 'px) and (max-width:' + maxSm + 'px)');
window.mediaBreakPointSmOnly = window.matchMedia('(min-width:' + smWidth + 'px) and (max-width:' + maxSm + 'px)');
window.mediaBreakPointMaxSm = window.matchMedia('(max-width:' + maxSm + 'px)'); 
window.mediaBreakPointMinSmMaxMd = window.matchMedia('(min-width:' + smWidth + 'px) and (max-width:' + maxMd + 'px)');
window.mediaBreakPointMinMd = window.matchMedia('(min-width:' + mdWidth + 'px)');
window.mediaBreakPointMdOnly = window.matchMedia('(min-width:' + mdWidth + 'px) and (max-width:' + maxMd + 'px)');
window.mediaBreakPointMinLg = window.matchMedia('(min-width:' + lgWidth + 'px)');

window.$ = jQuery; 